import React, { useEffect, useRef } from "react";

export default function RandomRisingParticles() {
  const ref = useRef(null);

  useEffect(() => {
    const container = ref.current;
    const particleCount = 30; 

    for (let i = 0; i < particleCount; i++) {
      const dot = document.createElement("div");
      dot.className = "dot";

      // Rastgele X pozisyonu
      dot.style.left = Math.random() * 100 + "%";

      // Rastgele animasyon gecikmesi
      dot.style.animationDelay = Math.random() * 5 + "s";

      container.appendChild(dot);
    }

    return () => {
      container.innerHTML = "";
    };
  }, []);

  return (
    <>
      <style>{`
        .particle-bg {
          position: fixed;
          inset: 0;
          background: transparent;
          overflow: hidden;
          pointer-events: none;
          z-index: 1;
        }

        .dot {
          position: absolute;
          bottom: -10px;
          width: 3px;
          height: 3px;
          background: rgba(200, 200, 200, 0.7);
          border-radius: 50%;
          animation: rise 4s linear infinite;
        }

        @keyframes rise {
          0% {
            transform: translateY(0);
            opacity: 0;
          }
          10% {
            opacity: 0.6;
          }
          50% {
            opacity: 1;
          }
          90% {
            opacity: 0.3;
          }
          100% {
            transform: translateY(-120vh);
            opacity: 0;
          }
        }
      `}</style>

      <div className="particle-bg" ref={ref}></div>
    </>
  );
}